// extracted by mini-css-extract-plugin
export default {"main":"SelectionComponent_main__Bg1uz","content":"SelectionComponent_content__S4ObW","clear":"SelectionComponent_clear__UCADP"};